export default __webpack_public_path__ + "static/media/warning--frog-crossing--g1.cc552a98.png";